export const determineImageSize = ({ desktop, desktopMed, mobile, card }) => {
  const { innerWidth } = window;
  if (innerWidth >= 1200) return desktop;
  if (innerWidth >= 800) return desktopMed || card || desktop;
  return mobile;
};
